import styles from './index.module.css';

export enum LoadingSpinnerSize {
  Small = 'LoadingSpinnerSmall',
}

interface Props {
  size?: LoadingSpinnerSize;
}

export function LoadingSpinner(props: Props) {
  const { size = LoadingSpinnerSize.Small } = props;
  return (
    <div className={`${styles[size]}`}>
      <div className={styles.SpinnerArm} />
      <div className={`${styles.SpinnerArm2} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm3} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm4} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm5} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm6} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm7} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm8} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm9} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm10} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm11} ${styles.SpinnerArm}`} />
      <div className={`${styles.SpinnerArm12} ${styles.SpinnerArm}`} />
    </div>
  );
}
